import * as React from "react"
const CashCutSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={800}
    height={800}
    viewBox="0 0 128 128"
    {...props}
  >
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M88 0H16C7.164 0 0 7.164 0 16v72c0 8.836 7.164 16 16 16h33.168l8-4-8.004-4H16c-4.412 0-8-3.586-8-8V16c0-4.414 3.588-8 8-8h72c4.414 0 8 3.586 8 8v64.578l.32-.156c.914-5.031 3.754-9.367 7.68-12.336V16c0-8.836-7.164-16-16-16z"
      clipRule="evenodd"
    />
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M116 96c-6.629 0-12-5.375-12-12 0-6.629 5.371-12 12-12 6.625 0 12 5.371 12 12 0 6.625-5.375 12-12 12zm0-16a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM116 128c-6.629 0-12-5.375-12-12 0-6.629 5.371-12 12-12 6.625 0 12 5.371 12 12 0 6.625-5.375 12-12 12zm0-16c-2.211 0-4 1.789-4 4s1.789 4 4 4 4-1.789 4-4-1.789-4-4-4z"
      clipRule="evenodd"
    />
    <path
      fill="#FFF"
      d="M24 32h56v-8H24v8zM24 48h56v-8H24v8zM24 64h56v-8H24v8zM24 80h16v-8H24v8z"
    />
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M100.371 96.285 92.945 100l7.426 3.715c-1.656 2.082-2.918 4.48-3.637 7.117l-12.73-6.363-30.215 15.109a3.954 3.954 0 0 1-1.785.422 4 4 0 0 1-1.793-7.578L75.059 100 50.211 87.578a4 4 0 0 1 3.578-7.156L84 95.531l12.73-6.367c.715 2.641 1.981 5.035 3.641 7.121z"
      clipRule="evenodd"
    />
  </svg>
)
export default CashCutSVG
